import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import { getTranslation } from "utils/translation";

export const ErrorDisplay = () => {
  return (
    <ErrorAlert
      title={getTranslation("message", "ERROR.AN_UNKNOWN_ERROR_OCCURRED")}
      errorCode="error"
      buttonTitle={getTranslation("resource", "REFRESH")}
      onClick={() => window.location.reload()}
    >
      <p>
        {getTranslation("message", "ERROR.APOLOGIZE_FOR_INCONVENIENCE")}
        <br />
        {getTranslation("message", "ERROR.PLEASE_CONTACT_SYNCBOX")}
      </p>
    </ErrorAlert>
  );
};
